import { EnvironmentService, PrintingDocumentTemplate, PrintingLabel, PrintingReceipt, PrintingService, PrintingTemplateService, SessionService, TemplateAreaTypes } from '@absg/nim-client-shared';
import { Injectable, OnDestroy } from '@angular/core';
import { map } from 'rxjs/operators';
import { SubSink } from 'subsink';

@Injectable({ providedIn: 'root' })
export class StationPrintingService implements OnDestroy {
  subSink = new SubSink();

  constructor(
    private printingService: PrintingService,
    private printingTemplateService: PrintingTemplateService,
    private sessionService: SessionService,
    private environmentService: EnvironmentService,
  ) {
    this.subSink.sink = this.environmentService.maxReceiptCount$.pipe(map((maxValue) => {
      this.printingService.setMaxTransactions(maxValue);
    })).subscribe();
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  clearCachedE2EPrintData(): void {
    this.printingService.clearCachedE2EPrintData();
  }

  printLabels(printingLabels: PrintingLabel[]): void {
    const practiceInfo = this.sessionService.practiceLite.value;
    const template = this.printingTemplateService.getLabelTemplate(TemplateAreaTypes.dispense, practiceInfo);
    if (printingLabels && printingLabels.length > 0) {
      this.printingService.printLabels(printingLabels, template);
    }
  }

  printSingleDispenseItemLabels(printingLabel: PrintingLabel): void {
    const practiceInfo = this.sessionService.practiceLite.value;
    const template = this.printingTemplateService.getLabelTemplate(TemplateAreaTypes.dispense, practiceInfo);
    if (printingLabel) {
      this.printingService.printSingleDispenseItemLabels(printingLabel, template);
    }
  }

  printCombinedDispenseItemLabels(printingLabel: PrintingLabel): void {
    const practiceInfo = this.sessionService.practiceLite.value;
    const printingLabelTemplate = this.printingTemplateService.getLabelTemplate(TemplateAreaTypes.dispense, practiceInfo);
    this.printingService.printCombinedDispenseItemLabels(printingLabel, printingLabelTemplate);
  }

  printDispenseReceipt(printingReceipt: PrintingReceipt): void {
    const practiceInfo = this.sessionService.practiceLite.value;
    const printingReceiptTemplate = this.printingTemplateService.getReceiptTemplate(TemplateAreaTypes.dispense, practiceInfo);
    this.AppendSplitReceipt(printingReceiptTemplate);
    this.printingService.printReceipt(printingReceipt, printingReceiptTemplate);
  }

  printReturnReceipt(printingReceipt: PrintingReceipt): void {
    const practiceInfo = this.sessionService.practiceLite.value;
    const printingReceiptTemplate = this.printingTemplateService.getReceiptTemplate(TemplateAreaTypes.return, practiceInfo);
    this.AppendSplitReceipt(printingReceiptTemplate);
    this.printingService.printReceipt(printingReceipt, printingReceiptTemplate);
  }

  printWasteReceipt(printingReceipt: PrintingReceipt): void {
    const practiceInfo = this.sessionService.practiceLite.value;
    const printingReceiptTemplate = this.printingTemplateService.getReceiptTemplate(TemplateAreaTypes.waste, practiceInfo);
    this.AppendSplitReceipt(printingReceiptTemplate);
    this.printingService.printReceipt(printingReceipt, printingReceiptTemplate);
  }

  printRestockReceipt(printingReceipt: PrintingReceipt): void {
    const practiceInfo = this.sessionService.practiceLite.value;
    const printingReceiptTemplate = this.printingTemplateService.getReceiptTemplate(TemplateAreaTypes.restock, practiceInfo);
    this.AppendSplitReceipt(printingReceiptTemplate);
    this.printingService.printReceipt(printingReceipt, printingReceiptTemplate);
  }

  printClinicChargeReceipt(printingReceipt: PrintingReceipt): void {
    const practiceInfo = this.sessionService.practiceLite.value;
    const printingReceiptTemplate = this.printingTemplateService.getReceiptTemplate(TemplateAreaTypes.clinicCharge, practiceInfo);
    this.AppendSplitReceipt(printingReceiptTemplate);
    this.printingService.printReceipt(printingReceipt, printingReceiptTemplate);
  }

  printUnloadReceipt(printingReceipt: PrintingReceipt): void {
    const practiceInfo = this.sessionService.practiceLite.value;
    const printingReceiptTemplate = this.printingTemplateService.getReceiptTemplate(TemplateAreaTypes.unload, practiceInfo);
    this.AppendSplitReceipt(printingReceiptTemplate);
    this.printingService.printReceipt(printingReceipt, printingReceiptTemplate);
  }

  printTransferReceipt(printingReceipt: PrintingReceipt): void {
    const practiceInfo = this.sessionService.practiceLite.value;
    const printingReceiptTemplate = this.printingTemplateService.getReceiptTemplate(TemplateAreaTypes.transfer, practiceInfo);
    this.AppendSplitReceipt(printingReceiptTemplate);
    this.printingService.printReceipt(printingReceipt, printingReceiptTemplate);
  }

  private AppendSplitReceipt(printingReceiptTemplate: PrintingDocumentTemplate): void {
    if (this.environmentService.usingSplitReceipts()) {
      printingReceiptTemplate.isSetPageHeight = true;
      printingReceiptTemplate.maxPageHeight = this.environmentService.getMaxReceiptLength() ?? 17;
    }
  }
}
